// angular
import { Component, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// services
import { StateManagementService } from '@app/+chat/shared/services/state-management.service';

@Component({
  selector: 'pwj-suggest-message-box',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './suggest-message-box.component.html',
  styleUrl: './suggest-message-box.component.scss',
})
export class SuggestMessageBoxComponent {
  // inputs
  suggestedMessage = input.required<string>();

  // dependencies
  private readonly _stateManagementService = inject(StateManagementService);

  constructor() {}

  public onSelectMessage(message: string) {
    this._stateManagementService.selectedSuggestionMessage.set(message);
  }
}
